import { useContext } from 'react';

import { AlertsActionContext } from './constants';

const useAlertsActionContext = () => {
  return useContext(AlertsActionContext);
};

export default useAlertsActionContext;
